import type { FaireProductEntity } from "../../entity_types/product";

export const p_6djgvu4bvs: FaireProductEntity = {
  token: "p_6djgvu4bvs",
  type: "product",
  name: "The Georgia Stone Huggies Set- Gold",
  brandToken: "b_2p3pcs27",
  brandName: "Luv AJ",
  imageUrl:
    "https://cdn.faire.com/fastly/fbea922b8019ab94c65d5f8b736e833d6be2c81a4f585514acbd8c4d8cf97fa1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8eca4a6d6d9f275a3d6e3c2214470c221946d8c720df3fb25da0d98bef969cdb.jpeg",
    "https://cdn.faire.com/fastly/de1e4b1353395ba5bb5d1368e9c115667af53b5b9e11078f0730acba87b2cfaa.jpeg",
    "https://cdn.faire.com/fastly/17ac5a8665e1495e0eabbba26507b80f9cac5deb55bb0df0a993d4d6c9888db4.jpeg",
  ],
  priceDollars: 52,
  description:
    "𝐃𝐞𝐭𝐚𝐢𝐥𝐬\n\n• Double hinge hoops with tennis necklace-style chain in between\n• Earrings are 11mm x 2mm\n• Each pair weighs 4.54 grams\n• Comes as a set of two\n• All LuvAj.com orders are sent in Luv Aj branded gift boxes or packaging\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬\n\n• Made from plated brass with CZ stones\n• Plating is waterproof and tarnish free\n• 14K plated brass and Rhodium plated silver with E-Coating\n• Plating details: 0.3 microns + e-coating for long lasting durability\n• Plated high polish 14K Gold or Rhodium for maximum shine\n• Posts are made from surgical steel so they are very hypo-allergenic for sensitive ears\n• Earrings are 100% nickel-free and cadmium-free",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:35.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
